<template>
    <elementary-section>
        <form @submit.prevent="submit">
            <catalogue-column-container/>
            <catalogue-filter-container/>
            <div class="m--t-2">
                <custom-button v-saved-status:[status] type="submit" outline :disabled="processing"
                               success-message="Uloženo">
                    Uložit
                </custom-button>
            </div>
        </form>
    </elementary-section>
</template>

<script>
import CatalogueColumnContainer
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Catalogue/Column/CatalogueColumnContainer';
import CatalogueFilterContainer
    from '@/modules/ProjectModule/modules/ExtensionModule/components/Catalogue/Filter/CatalogueFilterContainer';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';
import ElementarySection from '@/components/Content/ElementarySection';

export default {
    name:       'CatalogueContainer',
    components: {ElementarySection, CatalogueFilterContainer, CatalogueColumnContainer, CustomButton},
    data() {
        return {
            status:     0,
            processing: false,
            statusName: 'status',
        }
    },
    methods:    {
        submit() {
            this.processing = true;
            this.$store.dispatch('projects/project/extension/catalogue/save')
                .then(() => this.status++)
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => this.processing = false);
        }
    }
}
</script>
